import { configureStore } from "@reduxjs/toolkit"
import MSALSlice from "./slices/MSALSlice"
import APIResponseSlice from "./slices/APIResponseSlice"

export const store = configureStore({
  reducer: {
    MSALAuth: MSALSlice,
    APIResponse: APIResponseSlice,
  },
})